export default __webpack_public_path__ + "static/media/TDSF.9516673d.png";